export default __webpack_public_path__ + "static/media/Catálogo_tvs_ntorq_125_racing.64679bb2.pdf";